import { StoreAction } from "../../@core/constants/action";

const initialState = { celebrationList: [] };

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_CELEBRATION_DATA:
      return { ...state, celebrationList: action.payload };
    default:
      return state;
  }
}
